import { isNumber } from 'lodash';
import { PdfModule } from '../pdf-module';
import template from '../template/print_bill_lite.svg';
import { HAGIWARA_LOGO_PNG } from '../template/hagiwara_logo';

type ChangeParam = {key: string, change: string}

const replaceData = [
  {
    from: '%%printBillLite1_1_%%', to: 'name', someLine: true, adjustKey: ('adjustName' as keyof BillLiteParam),
  },
  { from: '%%printBillLite1_2_%%', to: 'date' },
  {
    from: '%%printBillLite1_3_%%', to: 'projectName', someLine: true, adjustKey: ('adjustProjectName' as keyof BillLiteParam),
  },
  { from: '%%printBillLite1_4_%%', to: 'zeikomiPrice' },
  { from: '%%printBillLite1_5_%%', to: 'price' },
  { from: '%%printBillLite1_6_%%', to: 'totalSyouhizeiPrice' },
  {
    from: '%%printBillLite1_7_%%', to: 'company', someLine: true, adjustKey: ('adjustCompanyName' as keyof BillLiteParam),
  },
  { from: '%%printBillLite1_8_%%', to: 'companyShiten' },
  { from: '%%printBillLite1_9_%%', to: 'post' },
  { from: '%%printBillLite1_10_%%', to: 'address' },
  { from: '%%printBillLite1_11_%%', to: 'tel' },
  { from: '%%printBillLite1_12_%%', to: 'fax' },
  { from: '%%printBillLite1_13_%%', to: 'freeDial' },
  { from: '%%printBillLite1_14_%%', to: 'icon' },
  { from: '%%printBillLite1_15_%{i}_%%', to: 'banks0' },
  { from: '%%printBillLite1_16_%{i}_%%', to: 'banks1' },
  { from: '%%printBillLite1_17_%{i}_%%', to: 'banks2' },
  { from: '%%printBillLite1_18_%{i}_%%', to: 'banks3' },
  { from: '%%printBillLite1_43_%%', to: 'project_store_holder' },
  { from: '%%printBillLite1_35_%%', to: 'page' },
  { from: '%%printBillLite1_36_%{i}_%%', to: 'contract' },
  { from: '%%printBillLite1_37_%{i}_%%', to: 'construction' },
  { from: '%%printBillLite1_38_%{i}_%%', to: 'count' },
  { from: '%%printBillLite1_39_%{i}_%%', to: 'unit' },
  { from: '%%printBillLite1_40_%{i}_%%', to: 'constructionPrice' },
  { from: '%%printBillLite1_41_%{i}_%%', to: 'syouhizeiPrice' },
  { from: '%%printBillLite1_42_%%', to: 'iconTransform' },
  { from: '%%printBillLite1_44_%%', to: 'adjustCompany2' },
  { from: '%%printBillLite1_45_%%', to: 'adjustCompany' },
  { from: '%%printBillLite1_46_%%', to: 'adjustCompanyName' },
  { from: '%%printBillLite1_47_%%', to: 'companyNameLinePos' },
];

export type BillLiteParam = {
  // 顧客名
  name: string,
  adjustName?: number,
  // 日付
  date: string,
  // 税込み合計金額
  zeikomiPrice: string,
  // 工事名称
  projectName: string,
  adjustProjectName?: number,
  // 工事金額合計
  price: string,
  // 消費税額合計
  totalSyouhizeiPrice: string,
  // 振込先 (max : 5)
  banks: {
    banks0: string,
    banks1: string,
    banks2: string,
    banks3: string,
  }[],
  /** 案件担当店舗-口座名義 */
  project_store_holder: string;
  // アイコン
  icon: string,
  /** ロゴ画像の縦幅 */
  iconHeight: number,
  /** ロゴ画像の横幅 */
  iconWidth: number,
  /** ロゴ画像のスケール、位置調整 */
  iconTransform: string,
  // 会社名
  company: string,
  // 会社名2
  companyShiten: string,
  // 郵便番号
  post: string,
  // 住所
  address: string,
  // 電話番号
  tel: string,
  // FAX
  fax: string,
  // フリーダイヤル
  freeDial: string,
  // 内訳一覧
  breakdownList: {
    // 契約日
    contract: string,
    // 工事内訳
    construction: string,
    // 数量
    count: string,
    // 単位
    unit: string,
    // 工事金額
    constructionPrice: string,
    // 消費税
    syouhizeiPrice: string,
  }[],
  // 会社情報
  adjustCompany?: number,
  adjustCompany2?: number,
};

const defaultStr = '---';

const logoImageData = HAGIWARA_LOGO_PNG;

const defaultProps: BillLiteParam = {
  // 顧客名
  name: defaultStr,
  adjustName: undefined,
  // 日付
  date: defaultStr,
  // 税込み合計金額
  zeikomiPrice: defaultStr,
  // 工事名称
  projectName: defaultStr,
  adjustProjectName: undefined,
  // 工事金額合計
  price: defaultStr,
  // 消費税額合計
  totalSyouhizeiPrice: defaultStr,
  // 振込先 (max : 5)
  banks: [
    {
      banks0: defaultStr,
      banks1: defaultStr,
      banks2: defaultStr,
      banks3: defaultStr,
    },
  ],
  /** 案件担当店舗-口座名義 */
  project_store_holder: defaultStr,
  // アイコン
  icon: logoImageData,
  /** ロゴ画像の縦幅 */
  iconHeight: 0,
  /** ロゴ画像の横幅 */
  iconWidth: 0,
  /** ロゴ画像のスケール、位置調整 */
  iconTransform: '',
  // 会社名
  company: defaultStr,
  // 会社名2
  companyShiten: defaultStr,
  // 郵便番号
  post: defaultStr,
  // 住所
  address: defaultStr,
  // 電話番号
  tel: defaultStr,
  // FAX
  fax: defaultStr,
  // フリーダイヤル
  freeDial: defaultStr,
  // 内訳一覧
  breakdownList: [
    {
      // 契約日
      contract: defaultStr,
      // 工事内訳
      construction: defaultStr,
      // 数量
      count: defaultStr,
      // 単位
      unit: defaultStr,
      // 工事金額
      constructionPrice: defaultStr,
      // 消費税
      syouhizeiPrice: defaultStr,
    },
    {
      // 契約日
      contract: defaultStr,
      // 工事内訳
      construction: defaultStr,
      // 数量
      count: defaultStr,
      // 単位
      unit: defaultStr,
      // 工事金額
      constructionPrice: defaultStr,
      // 消費税
      syouhizeiPrice: defaultStr,
    },
  ],
  // 会社情報
  adjustCompany: 0,
  adjustCompany2: 0,
};

/**
 * 請求書
 */
export class BillLitePdfModule extends PdfModule<BillLiteParam> {
  constructor() {
    super(
      [
        template,
      ],
      replaceData,
    );
  }

  createSvg(
    _param: BillLiteParam = this.test(),
    templateSvgStrList: string[] = this.templateSvgStrCollection,
  ): string[] {
    const { iconHeight, iconWidth } = _param;
    const param:BillLiteParam = {
      ..._param,
      // iconTransform: this.getLogoTransform(
      //   { height: iconHeight, width: iconWidth },
      //   { height: 31.68, width: 172.08 },
      // ),
    };

    const height = 15;
    // 振込先の表示限界数
    const bankMaxLength = 6;
    const onePageRecord = 15;
    const recordHeight = 20.8;
    const pageNum = Math.ceil(param.breakdownList.length / onePageRecord);
    const templateSvgStr = templateSvgStrList[0] || '';
    if (param.banks.length > bankMaxLength) {
      window.console.warn('テンプレートに入らないサイズの銀行情報が入力されています。');
    }
    const replacedTemplateSvgStrList = [...new Array(pageNum)].fill(templateSvgStr)
      .map((page: string, pageIndex: number) => {
        let replacedPage = page;
        /** 振込先の処理 */
        for (let i = 0; i < param.banks.length; i += 1) {
          replacedPage = this.duplicateElement(
            replacedPage,
            'repeat_i',
            { x: 0, y: height * i },
            i,
            'i',
          );
        }
        /** 工事の処理 */
        // 残りの個数
        const restOfRowValue = param.breakdownList.length - pageIndex * onePageRecord;
        // 残りの個数から割り出した、繰り返しの終わり
        const endIndex = (restOfRowValue < onePageRecord) ? restOfRowValue : onePageRecord;
        for (let i = 0; i < endIndex; i += 1) {
          replacedPage = this.duplicateElement(
            replacedPage,
            'repeat_j',
            { x: 0, y: recordHeight * i },
            pageIndex * onePageRecord + i,
            'i',
          );
        }
        replacedPage = replacedPage.replace(/%%printBillLite1_35_%%/g, `${pageIndex + 1}/${pageNum}`);
        return replacedPage;
      });
    return super.createSvg(
      param, replacedTemplateSvgStrList, undefined, this.createChangeSizeArray(param),
    );
  }

  async createSvgList(
    param: BillLiteParam = defaultProps,
  ): Promise<string[]> {
    this.replaceData = this.replaceData.map((v) => {
      if (!v.someLine || !v.adjustKey) return v;
      if (!(param[v.to as keyof BillLiteParam] as string).match('\n')) return v;
      const lineSpan = param[v.adjustKey] as number | undefined;
      return { ...v, lineSpan };
    });
    return super.createSvgList(param, undefined, this.createChangeSizeArray(param));
  }

  private createChangeSizeArray = (param: BillLiteParam): ChangeParam[] | undefined => {
    const ary: ChangeParam[] = [];
    const find = this.replaceData.find((v) => v.to === 'name');
    const find2 = this.replaceData.find((v) => v.to === 'projectName');
    if (isNumber(param.adjustName)) {
      ary.push({
        key: '<text id="change_size_1_1" transform="translate(38.98 120.135)" style="font-size: 18px;fill: #222;">',
        change: `<text id="change_size_1_1" transform="translate(38.98 120.135)" style="font-size: ${param.adjustName}px;fill: #222;">`,
      });
    }
    if (isNumber(param.adjustProjectName)) {
      ary.push({
        key: '<text id="change_size_1_2" transform="translate(38.98 167.235)" style="font-size: 13.979999542236328px;fill: #222;">',
        change: `<text id="change_size_1_2" transform="translate(38.98 167.235)" style="font-size: ${param.adjustProjectName}px;fill: #222;">`,
      });
    }
    if (find) {
      if (isNumber(find.lineSpan)) {
        ary.push({
          key: '<line id="change_position_line_0_1" x1="36.7" y1="124.875" x2="336.72" y2="124.875" style="fill: none;stroke: #000;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1px"/>',
          change: `<line id="change_position_line_0_1" x1="36.7" y1="${124.875 + find.lineSpan}" x2="336.72" y2="${124.875 + find.lineSpan}" style="fill: none;stroke: #000;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1px"/>`,
        });
      }
    }
    if (find2) {
      if (isNumber(find2.lineSpan)) {
        ary.push({
          key: '<line id="change_position_0_2" x1="36.7" y1="169.575" x2="336.72" y2="169.575" style="fill: none;stroke: #000;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1px"/>',
          change: `<line id="change_position_0_2" x1="36.7" y1="${169.575 + find2.lineSpan}" x2="336.72" y2="${169.575 + find2.lineSpan}" style="fill: none;stroke: #000;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1px"/>`,
        });
      }
    }

    return ary.length ? ary : undefined;
  }

  test(): BillLiteParam {
    return {
      // 顧客名
      name: 'name',
      // 日付
      date: 'date',
      // 税込み合計金額
      zeikomiPrice: 'totalPrice',
      // 工事名称
      projectName: 'projectName',
      // 工事金額合計
      price: 'price',
      // 消費税額合計
      totalSyouhizeiPrice: 'taxPrice',
      // 振込先 (max : 5)
      banks: [...Array(5)].map((_, i) => ({
        banks0: `name${i}`,
        banks1: `shiten${i}`,
        banks2: `type${i}`,
        banks3: `number${i}`,
      })),
      /** 案件担当店舗-口座名義 */
      project_store_holder: defaultStr,
      // アイコン
      icon: logoImageData,
      /** ロゴ画像の縦幅 */
      iconHeight: 0,
      /** ロゴ画像の横幅 */
      iconWidth: 0,
      /** ロゴ画像のスケール、位置調整 */
      iconTransform: '',
      // 会社名
      company: 'company',
      // 会社名2
      companyShiten: 'company2',
      // 郵便番号
      post: 'post',
      // 住所
      address: 'address',
      // 電話番号
      tel: 'tel',
      // FAX
      fax: 'fax',
      // フリーダイヤル
      freeDial: 'freeDial',
      // 内訳一覧
      breakdownList: [...Array(43)].map((_, i) => ({
        // 契約日
        contract: `contract_${i}`,
        // 工事内訳
        construction: `construction_${i}`,
        // 数量
        count: `suryo_${i}`,
        // 単位
        unit: `unit_${i}`,
        // 工事金額
        constructionPrice: `price_${i}`,
        // 消費税
        syouhizeiPrice: `tax_${i}`,
      })),
      adjustCompany: 0,
    };
  }
}
